var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("q-form", { ref: "editForm" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            {
              staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
            },
            [
              _c(
                "c-card",
                {
                  staticClass: "cardClassDetailForm",
                  attrs: { title: "기본정보" },
                },
                [
                  _c("template", { slot: "card-detail" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6",
                      },
                      [
                        _c("c-plant", {
                          attrs: {
                            required: "",
                            editable: _vm.editable,
                            disabled: _vm.disabled,
                            type: "edit",
                            name: "plantCd",
                          },
                          model: {
                            value: _vm.tbmData.plantCd,
                            callback: function ($$v) {
                              _vm.$set(_vm.tbmData, "plantCd", $$v)
                            },
                            expression: "tbmData.plantCd",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6",
                      },
                      [
                        _c("c-dept", {
                          attrs: {
                            editable: _vm.editable,
                            disabled: _vm.disabled,
                            plantCd: _vm.tbmData.plantCd,
                            type: "edit",
                            label: "부서",
                            name: "deptCd",
                          },
                          model: {
                            value: _vm.tbmData.deptCd,
                            callback: function ($$v) {
                              _vm.$set(_vm.tbmData, "deptCd", $$v)
                            },
                            expression: "tbmData.deptCd",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
                      },
                      [
                        _c("c-vendor", {
                          attrs: {
                            editable: _vm.editable,
                            disabled: _vm.disabled,
                            haveProcess: true,
                            data: _vm.tbmData,
                            isWrite: "",
                            label: "업체",
                            name: "vendorCd",
                          },
                          model: {
                            value: _vm.tbmData.vendorCd,
                            callback: function ($$v) {
                              _vm.$set(_vm.tbmData, "vendorCd", $$v)
                            },
                            expression: "tbmData.vendorCd",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
                      },
                      [
                        _c("c-work-permit", {
                          attrs: {
                            editable: _vm.editable,
                            disabled: _vm.disabled,
                            isRemoveConfirm: true,
                            label: "작업허가번호 | 작업일",
                            name: "sopWorkPermitId",
                          },
                          on: {
                            dataChange: _vm.dataChange,
                            remove: _vm.removeWorkPermit,
                          },
                          model: {
                            value: _vm.tbmData.sopWorkPermitId,
                            callback: function ($$v) {
                              _vm.$set(_vm.tbmData, "sopWorkPermitId", $$v)
                            },
                            expression: "tbmData.sopWorkPermitId",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
                      },
                      [
                        _c("c-text", {
                          attrs: {
                            editable: _vm.editable,
                            disabled: true,
                            label: "TBM번호",
                            name: "tbmNo",
                          },
                          model: {
                            value: _vm.tbmData.tbmNo,
                            callback: function ($$v) {
                              _vm.$set(_vm.tbmData, "tbmNo", $$v)
                            },
                            expression: "tbmData.tbmNo",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
                      },
                      [
                        _c("c-text", {
                          attrs: {
                            required: "",
                            editable: _vm.editable,
                            disabled: _vm.disabled,
                            label: "TBM명",
                            name: "tbmName",
                          },
                          model: {
                            value: _vm.tbmData.tbmName,
                            callback: function ($$v) {
                              _vm.$set(_vm.tbmData, "tbmName", $$v)
                            },
                            expression: "tbmData.tbmName",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6",
                      },
                      [
                        _c("c-datepicker", {
                          attrs: {
                            required: "",
                            editable: _vm.editable,
                            disabled: _vm.disabled,
                            label: "TBM일자",
                            type: "date",
                            name: "tbmDate",
                          },
                          model: {
                            value: _vm.tbmData.tbmDate,
                            callback: function ($$v) {
                              _vm.$set(_vm.tbmData, "tbmDate", $$v)
                            },
                            expression: "tbmData.tbmDate",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6",
                      },
                      [
                        _c("c-datepicker", {
                          attrs: {
                            required: true,
                            disabled: _vm.disabled,
                            editable: _vm.editable,
                            range: true,
                            minuteStep: 10,
                            type: "time",
                            label: "TBM시간",
                            name: "workTime",
                          },
                          model: {
                            value: _vm.workTime,
                            callback: function ($$v) {
                              _vm.workTime = $$v
                            },
                            expression: "workTime",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
                      },
                      [
                        _c("c-textarea", {
                          attrs: {
                            editable: _vm.editable,
                            disabled: _vm.disabled,
                            label: "작업내용",
                            name: "tbmContents",
                          },
                          model: {
                            value: _vm.tbmData.tbmContents,
                            callback: function ($$v) {
                              _vm.$set(_vm.tbmData, "tbmContents", $$v)
                            },
                            expression: "tbmData.tbmContents",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
                      },
                      [
                        _c("c-text", {
                          attrs: {
                            editable: _vm.editable,
                            disabled: _vm.disabled,
                            label: "TBM장소",
                            name: "tbmLocation",
                          },
                          model: {
                            value: _vm.tbmData.tbmLocation,
                            callback: function ($$v) {
                              _vm.$set(_vm.tbmData, "tbmLocation", $$v)
                            },
                            expression: "tbmData.tbmLocation",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
                      },
                      [
                        _c("c-field", {
                          attrs: {
                            editable: _vm.editable,
                            disabled: _vm.disabled,
                            type: "dept_job_user",
                            label: "TBM리더",
                            name: "tbmLeaderId",
                          },
                          model: {
                            value: _vm.tbmData.tbmLeaderId,
                            callback: function ($$v) {
                              _vm.$set(_vm.tbmData, "tbmLeaderId", $$v)
                            },
                            expression: "tbmData.tbmLeaderId",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
            },
            [
              _c(
                "c-table",
                {
                  ref: "riskTable",
                  attrs: {
                    title: "위험요인 목록",
                    isTitle: "",
                    columns: _vm.riskGrid.columns,
                    data: _vm.tbmData.tbmRiskList,
                    filtering: false,
                    columnSetting: false,
                    usePaging: false,
                    isFullScreen: false,
                    isExcelDown: false,
                    editable: _vm.editable && !_vm.disabled,
                    rowKey: "tbmRiskId",
                    selection: "multiple",
                    gridHeightAuto: "",
                  },
                  on: { "table-data-change": _vm.tableDataChange },
                  scopedSlots: _vm._u([
                    {
                      key: "customArea",
                      fn: function ({ props, col }) {
                        return [
                          col.name === "tbmRisk"
                            ? [
                                props.row["tbmRiskType"] === "직접추가"
                                  ? _c("c-text-column", {
                                      attrs: {
                                        editable: _vm.editable,
                                        props: props,
                                        col: col,
                                        disabled: _vm.disabled,
                                      },
                                      on: {
                                        datachange1: function ($event) {
                                          return _vm.datachange1(props)
                                        },
                                      },
                                      model: {
                                        value: props.row["tbmRisk"],
                                        callback: function ($$v) {
                                          _vm.$set(props.row, "tbmRisk", $$v)
                                        },
                                        expression: "props.row['tbmRisk']",
                                      },
                                    })
                                  : _c("span", [
                                      _vm._v(
                                        " " + _vm._s(props.row["tbmRisk"]) + " "
                                      ),
                                    ]),
                              ]
                            : _vm._e(),
                          col.name === "customColRisk"
                            ? [
                                _c(_vm.detailRisk, {
                                  tag: "component",
                                  attrs: {
                                    col: col,
                                    props: props,
                                    rowIndex: props.rowIndex,
                                    tableKey: "tbmRiskId",
                                  },
                                  on: { closeRiskDetail: _vm.closeRiskDetail },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "customArea",
                                        fn: function ({ props }) {
                                          return [
                                            _c(
                                              "q-form",
                                              { ref: "editForm3" },
                                              [
                                                _c(
                                                  "c-card",
                                                  {
                                                    staticClass:
                                                      "cardClassDetailForm q-mb-sm",
                                                    attrs: {
                                                      title:
                                                        "위험요인 세부 정보",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "template",
                                                      { slot: "card-detail" },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-12",
                                                          },
                                                          [
                                                            _c("c-textarea", {
                                                              attrs: {
                                                                disabled:
                                                                  _vm.popupParam
                                                                    .disabled ||
                                                                  props.row[
                                                                    "tbmRiskType"
                                                                  ] !==
                                                                    "직접추가",
                                                                editable:
                                                                  _vm.editable,
                                                                label:
                                                                  "위험요인",
                                                                name: "tbmRisk",
                                                              },
                                                              model: {
                                                                value:
                                                                  props.row
                                                                    .tbmRisk,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      props.row,
                                                                      "tbmRisk",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "props.row.tbmRisk",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6",
                                                          },
                                                          [
                                                            _c("c-select", {
                                                              attrs: {
                                                                disabled:
                                                                  _vm.popupParam
                                                                    .disabled,
                                                                codeGroupCd:
                                                                  "RAM_RISK_LEVEL_CD",
                                                                itemText:
                                                                  "codeName",
                                                                itemValue:
                                                                  "code",
                                                                type: "edit",
                                                                name: "beforeRisk",
                                                                label:
                                                                  "개선전 판단결과",
                                                              },
                                                              model: {
                                                                value:
                                                                  props.row
                                                                    .beforeRisk,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      props.row,
                                                                      "beforeRisk",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "props.row.beforeRisk",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-12",
                                                          },
                                                          [
                                                            _c("c-textarea", {
                                                              attrs: {
                                                                disabled:
                                                                  _vm.popupParam
                                                                    .disabled,
                                                                editable:
                                                                  _vm.editable,
                                                                label:
                                                                  "안전대책",
                                                                name: "tbmImprove",
                                                              },
                                                              model: {
                                                                value:
                                                                  props.row
                                                                    .tbmImprove,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      props.row,
                                                                      "tbmImprove",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "props.row.tbmImprove",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6",
                                                          },
                                                          [
                                                            _c("c-select", {
                                                              attrs: {
                                                                disabled:
                                                                  _vm.popupParam
                                                                    .disabled,
                                                                codeGroupCd:
                                                                  "RAM_RISK_LEVEL_CD",
                                                                itemText:
                                                                  "codeName",
                                                                itemValue:
                                                                  "code",
                                                                type: "edit",
                                                                name: "afterRisk",
                                                                label:
                                                                  "개선후 판단결과",
                                                              },
                                                              model: {
                                                                value:
                                                                  props.row
                                                                    .afterRisk,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      props.row,
                                                                      "afterRisk",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "props.row.afterRisk",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6",
                                                          },
                                                          [
                                                            _c("c-text", {
                                                              attrs: {
                                                                disabled: true,
                                                                editable:
                                                                  _vm.editable,
                                                                label: "구분",
                                                                name: "tbmRiskType",
                                                              },
                                                              model: {
                                                                value:
                                                                  props.row
                                                                    .tbmRiskType,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      props.row,
                                                                      "tbmRiskType",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "props.row.tbmRiskType",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  2
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ]
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "template",
                    { slot: "table-button" },
                    [
                      _c(
                        "q-btn-group",
                        { attrs: { outline: "" } },
                        [
                          _vm.editable && !_vm.disabled
                            ? _c("c-btn", {
                                attrs: {
                                  showLoading: false,
                                  label: "위험요인",
                                  icon: "add",
                                },
                                on: { btnClicked: _vm.addRiskFactor },
                              })
                            : _vm._e(),
                          _vm.editable && !_vm.disabled
                            ? _c("c-btn", {
                                attrs: {
                                  showLoading: false,
                                  label: "직접",
                                  icon: "add",
                                },
                                on: { btnClicked: _vm.addRisk },
                              })
                            : _vm._e(),
                          _vm.editable &&
                          !_vm.disabled &&
                          _vm.tbmData.tbmRiskList.length > 0
                            ? _c("c-btn", {
                                attrs: {
                                  showLoading: false,
                                  label: "",
                                  icon: "remove",
                                },
                                on: { btnClicked: _vm.removeRisk },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
            },
            [
              _c(
                "c-table",
                {
                  ref: "attendeeTable",
                  attrs: {
                    title: "참석자 목록",
                    isTitle: "",
                    columns: _vm.attendeeGrid.columns,
                    data: _vm.tbmData.tbmAttendeeList,
                    filtering: false,
                    columnSetting: false,
                    usePaging: false,
                    isFullScreen: false,
                    isExcelDown: false,
                    editable: _vm.editable && !_vm.disabled,
                    selection: "multiple",
                    rowKey: "tbmAttendeeId",
                    gridHeightAuto: "",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "customArea",
                      fn: function ({ props, col }) {
                        return [
                          col.name === "tbmAttendeeDept"
                            ? [
                                props.row["attendeeType"] === "직접추가"
                                  ? _c("c-text-column", {
                                      attrs: {
                                        editable: _vm.editable,
                                        props: props,
                                        col: col,
                                        disabled: _vm.disabled,
                                      },
                                      on: {
                                        datachange: function ($event) {
                                          return _vm.datachange(props)
                                        },
                                      },
                                      model: {
                                        value: props.row["tbmAttendeeDept"],
                                        callback: function ($$v) {
                                          _vm.$set(
                                            props.row,
                                            "tbmAttendeeDept",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "props.row['tbmAttendeeDept']",
                                      },
                                    })
                                  : _c("span", [
                                      _vm._v(
                                        " " +
                                          _vm._s(props.row["tbmAttendeeDept"]) +
                                          " "
                                      ),
                                    ]),
                              ]
                            : _vm._e(),
                          col.name === "tbmAttendeeJob"
                            ? [
                                props.row["attendeeType"] === "직접추가"
                                  ? _c("c-text-column", {
                                      attrs: {
                                        editable: _vm.editable,
                                        props: props,
                                        col: col,
                                        disabled: _vm.disabled,
                                      },
                                      on: {
                                        datachange: function ($event) {
                                          return _vm.datachange(props)
                                        },
                                      },
                                      model: {
                                        value: props.row["tbmAttendeeJob"],
                                        callback: function ($$v) {
                                          _vm.$set(
                                            props.row,
                                            "tbmAttendeeJob",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "props.row['tbmAttendeeJob']",
                                      },
                                    })
                                  : _c("span", [
                                      _vm._v(
                                        " " +
                                          _vm._s(props.row["tbmAttendeeJob"]) +
                                          " "
                                      ),
                                    ]),
                              ]
                            : _vm._e(),
                          col.name === "tbmAttendeeName"
                            ? [
                                props.row["attendeeType"] === "직접추가"
                                  ? _c("c-text-column", {
                                      attrs: {
                                        editable: _vm.editable,
                                        props: props,
                                        col: col,
                                        disabled: _vm.disabled,
                                      },
                                      on: {
                                        datachange: function ($event) {
                                          return _vm.datachange(props)
                                        },
                                      },
                                      model: {
                                        value: props.row["tbmAttendeeName"],
                                        callback: function ($$v) {
                                          _vm.$set(
                                            props.row,
                                            "tbmAttendeeName",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "props.row['tbmAttendeeName']",
                                      },
                                    })
                                  : _c("span", [
                                      _vm._v(
                                        " " +
                                          _vm._s(props.row["tbmAttendeeName"]) +
                                          " "
                                      ),
                                    ]),
                              ]
                            : _vm._e(),
                          col.name === "click" &&
                          props.row["attendeeType"] === "내부"
                            ? [
                                _c(
                                  "q-btn",
                                  {
                                    attrs: {
                                      round: "",
                                      unelevated: "",
                                      size: "xs",
                                      color: "amber",
                                      icon: "mode",
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return (() => {
                                          ;(_vm.rowIndex = props.rowIndex),
                                            (_vm.attendeeSign =
                                              props.row.attendeeSign)
                                        }).apply(null, arguments)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "q-popup-proxy",
                                      {
                                        ref: "proxy_" + props.rowIndex,
                                        attrs: { breakpoint: 400 },
                                      },
                                      [
                                        _c(col.component, {
                                          tag: "component",
                                          attrs: {
                                            outFlag: true,
                                            popupParam: props.row,
                                            data: _vm.tbmData,
                                            rowIndex: props.rowIndex,
                                          },
                                          on: {
                                            attendeeSignCallback:
                                              _vm.attendeeSignCallback,
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            : _vm._e(),
                          col.name === "customCol"
                            ? [
                                _c(_vm.detailComponent, {
                                  tag: "component",
                                  attrs: {
                                    col: col,
                                    props: props,
                                    rowIndex: props.rowIndex,
                                    tableKey: "tbmAttendeeId",
                                  },
                                  on: {
                                    closeAttendeeDetail:
                                      _vm.closeAttendeeDetail,
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "customArea",
                                        fn: function ({ props }) {
                                          return [
                                            _c(
                                              "q-form",
                                              { ref: "editForm2" },
                                              [
                                                _c(
                                                  "c-card",
                                                  {
                                                    staticClass:
                                                      "cardClassDetailForm q-mb-sm",
                                                    attrs: {
                                                      title: "참석자 세부 정보",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "template",
                                                      { slot: "card-detail" },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6",
                                                          },
                                                          [
                                                            _c("c-text", {
                                                              attrs: {
                                                                disabled:
                                                                  _vm.popupParam
                                                                    .disabled ||
                                                                  props.row[
                                                                    "attendeeType"
                                                                  ] !==
                                                                    "직접추가",
                                                                editable:
                                                                  _vm.editable,
                                                                label: "참석자",
                                                                name: "tbmAttendeeName",
                                                              },
                                                              on: {
                                                                dataChange:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.attendeeDataChange(
                                                                      props.row
                                                                    )
                                                                  },
                                                              },
                                                              model: {
                                                                value:
                                                                  props.row
                                                                    .tbmAttendeeName,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      props.row,
                                                                      "tbmAttendeeName",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "props.row.tbmAttendeeName",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6",
                                                          },
                                                          [
                                                            _c("c-text", {
                                                              attrs: {
                                                                disabled:
                                                                  _vm.popupParam
                                                                    .disabled ||
                                                                  props.row[
                                                                    "attendeeType"
                                                                  ] !==
                                                                    "직접추가",
                                                                editable:
                                                                  _vm.editable,
                                                                label: "직책",
                                                                name: "tbmAttendeeJob",
                                                              },
                                                              on: {
                                                                dataChange:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.attendeeDataChange(
                                                                      props.row
                                                                    )
                                                                  },
                                                              },
                                                              model: {
                                                                value:
                                                                  props.row
                                                                    .tbmAttendeeJob,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      props.row,
                                                                      "tbmAttendeeJob",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "props.row.tbmAttendeeJob",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6",
                                                          },
                                                          [
                                                            _c("c-textarea", {
                                                              attrs: {
                                                                disabled:
                                                                  _vm.popupParam
                                                                    .disabled,
                                                                editable:
                                                                  _vm.editable,
                                                                rows: 2,
                                                                label:
                                                                  "참석자 비고",
                                                                name: "remark",
                                                              },
                                                              on: {
                                                                dataChange:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.attendeeDataChange(
                                                                      props.row
                                                                    )
                                                                  },
                                                              },
                                                              model: {
                                                                value:
                                                                  props.row
                                                                    .remark,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      props.row,
                                                                      "remark",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "props.row.remark",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6",
                                                          },
                                                          [
                                                            _c("c-select", {
                                                              attrs: {
                                                                disabled:
                                                                  _vm.popupParam
                                                                    .disabled,
                                                                comboItems:
                                                                  _vm.flagItems,
                                                                itemText:
                                                                  "codeName",
                                                                itemValue:
                                                                  "code",
                                                                label:
                                                                  "정신적피로",
                                                                name: "mentalFlag",
                                                              },
                                                              on: {
                                                                datachange:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.attendeeDataChange(
                                                                      props.row
                                                                    )
                                                                  },
                                                              },
                                                              model: {
                                                                value:
                                                                  props.row
                                                                    .mentalFlag,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      props.row,
                                                                      "mentalFlag",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "props.row.mentalFlag",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6",
                                                          },
                                                          [
                                                            _c("c-select", {
                                                              attrs: {
                                                                disabled:
                                                                  _vm.popupParam
                                                                    .disabled,
                                                                comboItems:
                                                                  _vm.flagItems,
                                                                itemText:
                                                                  "codeName",
                                                                itemValue:
                                                                  "code",
                                                                label:
                                                                  "심리적피로",
                                                                name: "phychologicalFlag",
                                                              },
                                                              on: {
                                                                datachange:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.attendeeDataChange(
                                                                      props.row
                                                                    )
                                                                  },
                                                              },
                                                              model: {
                                                                value:
                                                                  props.row
                                                                    .phychologicalFlag,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      props.row,
                                                                      "phychologicalFlag",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "props.row.phychologicalFlag",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6",
                                                          },
                                                          [
                                                            _c("c-select", {
                                                              attrs: {
                                                                disabled:
                                                                  _vm.popupParam
                                                                    .disabled,
                                                                comboItems:
                                                                  _vm.flagItems,
                                                                itemText:
                                                                  "codeName",
                                                                itemValue:
                                                                  "code",
                                                                label:
                                                                  "육체적피로",
                                                                name: "physicalFlag",
                                                              },
                                                              on: {
                                                                datachange:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.attendeeDataChange(
                                                                      props.row
                                                                    )
                                                                  },
                                                              },
                                                              model: {
                                                                value:
                                                                  props.row
                                                                    .physicalFlag,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      props.row,
                                                                      "physicalFlag",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "props.row.physicalFlag",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6",
                                                          },
                                                          [
                                                            _c("c-select", {
                                                              attrs: {
                                                                disabled:
                                                                  _vm.popupParam
                                                                    .disabled,
                                                                comboItems:
                                                                  _vm.flagItems,
                                                                itemText:
                                                                  "codeName",
                                                                itemValue:
                                                                  "code",
                                                                label:
                                                                  "신체적결함",
                                                                name: "physicalDefectFlag",
                                                              },
                                                              on: {
                                                                datachange:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.attendeeDataChange(
                                                                      props.row
                                                                    )
                                                                  },
                                                              },
                                                              model: {
                                                                value:
                                                                  props.row
                                                                    .physicalDefectFlag,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      props.row,
                                                                      "physicalDefectFlag",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "props.row.physicalDefectFlag",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6",
                                                          },
                                                          [
                                                            _c("c-select", {
                                                              attrs: {
                                                                disabled:
                                                                  _vm.popupParam
                                                                    .disabled,
                                                                codeGroupCd:
                                                                  "TBM_HEALTH_STATUS_CD",
                                                                type: "search",
                                                                itemText:
                                                                  "codeName",
                                                                itemValue:
                                                                  "code",
                                                                name: "healthStatusCd",
                                                                label:
                                                                  "건강상태",
                                                              },
                                                              on: {
                                                                datachange:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.attendeeDataChange(
                                                                      props.row
                                                                    )
                                                                  },
                                                              },
                                                              model: {
                                                                value:
                                                                  props.row
                                                                    .healthStatusCd,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      props.row,
                                                                      "healthStatusCd",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "props.row.healthStatusCd",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  2
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ]
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "template",
                    { slot: "table-button" },
                    [
                      _c(
                        "q-btn-group",
                        { attrs: { outline: "" } },
                        [
                          _vm.editable && !_vm.disabled
                            ? _c("c-btn", {
                                attrs: {
                                  showLoading: false,
                                  label: "협력",
                                  icon: "add",
                                },
                                on: { btnClicked: _vm.addAttendeePartner },
                              })
                            : _vm._e(),
                          _vm.editable && !_vm.disabled
                            ? _c("c-btn", {
                                attrs: {
                                  showLoading: false,
                                  label: "현업",
                                  icon: "add",
                                },
                                on: { btnClicked: _vm.addAttendee },
                              })
                            : _vm._e(),
                          _vm.editable && !_vm.disabled
                            ? _c("c-btn", {
                                attrs: {
                                  showLoading: false,
                                  label: "직접",
                                  icon: "add",
                                },
                                on: { btnClicked: _vm.addAttendeeDirect },
                              })
                            : _vm._e(),
                          _vm.editable &&
                          !_vm.disabled &&
                          _vm.tbmData.tbmAttendeeList.length > 0
                            ? _c("c-btn", {
                                attrs: {
                                  showLoading: false,
                                  label: "",
                                  icon: "remove",
                                },
                                on: { btnClicked: _vm.removeAttendee },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c("c-upload", {
                attrs: {
                  attachInfo: _vm.attachInfo,
                  editable: _vm.editable && !_vm.disabled,
                  label: "교육자료, 참석자서명, 증빙사진",
                },
              }),
            ],
            1
          ),
        ]),
      ]),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
      _c("div", { staticClass: "popup-bottom-bar" }, [
        _c(
          "div",
          { staticClass: "popup-bottom-bar-btngroup" },
          [
            _c(
              "q-btn-group",
              { attrs: { outline: "" } },
              [
                _c("c-btn", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.editable,
                      expression: "!editable",
                    },
                  ],
                  attrs: {
                    flat: true,
                    label: "작성 권한이 없습니다.",
                    icon: "warning",
                  },
                }),
                _c("c-btn", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.editable && !_vm.isOld,
                      expression: "editable && !isOld",
                    },
                  ],
                  attrs: { flat: true, label: "불러오기", icon: "save_alt" },
                  on: { btnClicked: _vm.copyTbm },
                }),
                _c("c-btn", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.editable && _vm.isOld && !_vm.disabled,
                      expression: "editable && isOld && !disabled",
                    },
                  ],
                  attrs: {
                    flat: true,
                    label: "삭제",
                    editable: _vm.editable,
                    icon: "delete_forever",
                  },
                  on: { btnClicked: _vm.remove },
                }),
                _c("c-btn", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.editable && !_vm.disabled,
                      expression: "editable && !disabled",
                    },
                  ],
                  attrs: {
                    flat: true,
                    url: _vm.saveUrl,
                    isSubmit: _vm.isSave,
                    param: _vm.tbmData,
                    mappingType: _vm.saveType,
                    label: "저장",
                    icon: "save",
                  },
                  on: {
                    beforeAction: _vm.saveTbm,
                    btnCallback: _vm.saveCallback,
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "popup-bottom-bar-close" },
          [
            _c("q-btn", {
              attrs: { flat: "", color: "gray", icon: "arrow_back" },
              on: { click: _vm.closePopUps },
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }